// The rebellion page's copy, shared by its components and its Markdown.

export const rebellionHero = {
  eyebrow: "Join the rebellion",
  title: "A new developer lifecycle is coming. We're rebuilding it.",
  intro:
    "Regular updates from the front lines. Developer news, curated content, early access, and exclusive drops for people who got here first.",
}

export interface RebellionBenefit {
  label: string
  title: string
  detail: string
}

export const rebellionBenefits: RebellionBenefit[] = [
  {
    label: "Regular newsletter",
    title: "Checkpoints from the team rebuilding the developer lifecycle.",
    detail: "Developer news, curated links, technical notes, and the work behind Entire.",
  },
  {
    label: "Early access",
    title: "First look at features before they ship broadly.",
    detail: "Invites when new workflows are ready for the open-source CLI and entire.com.",
  },
  {
    label: "Exclusive drops",
    title: "Curated content, technical deep-dives, and goods for the early crew.",
    detail: "Rare extras when there is something useful, interesting, or fun to send.",
  },
]
